import React, { useState } from "react";
import { EMOJIS, FEELINGS } from "../lib/api";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Smile, Sparkles } from "lucide-react";

export function EmojiButton({ onPick, testid = "emoji-button" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} title="Add emoji"
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border-2 border-black text-xs font-heading font-bold bg-white hover:bg-spotter-cream">
          <Smile className="w-4 h-4 text-spotter-gold" />Emoji
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 border-2 border-black bg-white p-2">
        <div className="grid grid-cols-6 gap-1">
          {EMOJIS.map((e) => (
            <button key={e} type="button" data-testid={`emoji-${e}`} onClick={() => { onPick(e); setOpen(false); }}
              className="text-xl p-1 rounded hover:bg-spotter-cream">{e}</button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export function FeelingButton({ value, onPick, testid = "feeling-button" }) {
  const [open, setOpen] = useState(false);
  const current = FEELINGS.find((f) => f.label === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} title="Feeling / activity"
          className={`inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border-2 border-black text-xs font-heading font-bold ${value ? "bg-spotter-gold/40" : "bg-white hover:bg-spotter-cream"}`}>
          <Sparkles className="w-4 h-4 text-spotter-gold" />{current ? `${current.emoji} ${current.label}` : "Feeling / activity"}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-60 border-2 border-black bg-white p-2 max-h-72 overflow-y-auto">
        {value && (
          <button type="button" data-testid="feeling-clear" onClick={() => { onPick(null); setOpen(false); }}
            className="w-full text-left text-xs text-red-700 font-bold px-2 py-1.5 rounded hover:bg-spotter-cream mb-1">Clear feeling</button>
        )}
        <div className="space-y-0.5">
          {FEELINGS.map((f) => (
            <button key={f.label} type="button" data-testid={`feeling-${f.label}`} onClick={() => { onPick(f.label); setOpen(false); }}
              className={`w-full flex items-center gap-2 text-sm px-2 py-1.5 rounded hover:bg-spotter-cream ${value === f.label ? "bg-spotter-gold/30 font-bold" : ""}`}>
              <span className="text-lg">{f.emoji}</span>{f.label}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
